import Linker from './central/linker';
window.$servicePortal = window.$servicePortal || {};
var scripts = document.getElementsByTagName('script');
for (var i = scripts.length - 1; i >= 0; i--) {
    var appScript = scripts[i];
    if (appScript.src) {
        var appBundleIndex = appScript.src.indexOf('/vendor-rub-serviceportal.js');
        if (appBundleIndex > -1) {
            var cdnBasePath = appScript.src.substr(0, appBundleIndex);
            window.$servicePortal.cdnBasePath = cdnBasePath;
            var revIndex = appScript.src.indexOf('rev=');
            if (revIndex > -1) {
                window.$servicePortal.rev = appScript.src.substr(revIndex + 4);
            }
            if (!window.$servicePortal.rev) {
                var now = new Date();
                window.$servicePortal.rev = "" + now.getFullYear() + now.getMonth() + (now.getDate() - now.getDay());
            }
            break;
        }
    }
}
var linker = new Linker('$servicePortal');
window.$servicePortal.linker = linker;
export default linker;
